import { locales, recursiveMerge } from '@/plugins/xtpgui';

export default recursiveMerge(locales.enUS, {
    'customer.title'                : 'Supplier Registration',
    'customer.search'               : 'Search',
    'customer.edit'                 : 'Edit',
    'countries.search'              : 'Search',
    'countries.edit'                : 'Edit',
    'countries.title'               : 'Country Registration',
    'MovimentosEmAberto.search'      : 'Search',
    'MovimentosEmAberto.edit'        : 'Edit',
    'MovimentosEmAberto.title'       : 'Entry of Transactions',
 

    $vuetify: {},

    $dataTable: {},
});